import { filespaceNameValidator } from '@lucidlink/dto/validation';
import { z } from '@lucidlink/dto/z';
export const filespaceRenameFormParser = z.object({
    name: filespaceNameValidator,
});
